import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  items: [],
  map: {},
  loaded: false,
  version: 1,
}

const featureSlice = createSlice({
  name: 'auth/features',
  initialState,
  reducers: {
    setFeatures: (_state, action) => {
      const features = action.payload?.features || []
      return {
        items: features,
        map: Object.fromEntries(features.map(f => [f, true])),
        loaded: true,
        version: action.payload?.version ?? 1,
      }
    },
    clearFeatures: () => initialState,
  },
})

export const { setFeatures, clearFeatures } = featureSlice.actions
export default featureSlice.reducer

// selectors
export const selectFeaturesLoaded = (s) => !!s?.auth?.feature?.loaded
export const selectHasFeature = (s, feature) =>
  !!s?.auth?.feature?.map?.[feature]
export const selectFeaturesMap = (s) => s?.auth?.feature?.map ?? {}
export const selectFeaturesNode = (s) => s?.auth?.feature ?? null
